import { Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { TextBtn } from "../../shared";
import dayjs from "dayjs";
import { Carousel as CarouselAntd } from "antd"
import CunstomAbleCarousel from "../../shared/carousel/cunstomAbleCarousel";
import { useEffect, useRef, useState } from "react";

interface IMyProgramBooking {
    programBookingId: number
    programThumbnailImageUrl: string
    programTitle: string
    targetDateTime: string
    programLocationName: string
}
interface IMergeData {
    id: number;
    title: string;
    imageUrl: string;
    locationName: string;
    type: string;
    startDateTime: string;
}

interface IProps {
    dosanProgramMember: IDosanProgramMember | undefined;
    myReservationList: IReservationMyWebResponseV2[];
    programBookingList: IMyProgramBooking[];
}

const ReservatedProgramList = ({ dosanProgramMember, myReservationList, programBookingList }: IProps) => {
    const navigate = useNavigate();
    const [carouselWidth, setCarouselWidth] = useState<number>(320);
    const fristRef = useRef<HTMLDivElement | null>(null)

    const mergedList: IMergeData[] = [
        ...myReservationList.map(reservation => ({
            id: reservation.wellnessLectureId,
            title: reservation.wellnessLectureName,
            imageUrl: reservation.teacherProfileImageUrl,
            locationName: reservation.yogaCenterName + " " + reservation.wellnessLectureRoom,
            type: 'reservation',
            startDateTime: reservation.wellnessLectureStartDateTime,
        })),
        ...programBookingList.map(program => ({
            id: program.programBookingId,
            title: program.programTitle,
            imageUrl: program.programThumbnailImageUrl,
            locationName: program.programLocationName,
            type: 'program',
            startDateTime: program.targetDateTime
        }))
    ].filter(data => dayjs(data.startDateTime).isAfter(dayjs()));

    const sortedList = mergedList.sort((a, b) => {
        return dayjs(a.startDateTime).diff(dayjs(b.startDateTime));
    });

    useEffect(() => {
        setCarouselWidth(fristRef.current?.getBoundingClientRect().width ?? 320)
    }, [fristRef.current?.getBoundingClientRect().width])

    return <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space20)' }}>
        <div className="title/t1" style={{ paddingInline: 'var(--space20)' }}>다가오는 프로그램</div>
        {dosanProgramMember &&
            <>
                <div style={{ backgroundColor: '#000000', fontSize: '13px', color: '#ffffff', display: 'flex', alignItems: 'center', marginTop: '28px', borderRadius: "4px", padding: '12px 16px', gap: '16px' }} onClick={() => navigate('/invitation/dosan/program')}>
                    <div><img alt="" src={`${process.env.PUBLIC_URL}/assets/icon/ClubhouseProgram.svg`} /></div>
                    <div>
                        <div style={{ color: '#F4F4F4', fontSize: '12px', lineHeight: '20px' }}>{dosanProgramMember?.startDate}</div>
                        <div style={{ marginTop: '4px', color: '#ffffff', fontSize: '16px', lineHeight: '23px', fontFamily: 'TuskerGrotesk6500Medium' }}>GOOD IN BAD OUT</div>
                    </div>
                </div>
            </>}
        <div>
            {sortedList.length === 0
                ? <div style={{ paddingInline: 20 }}>
                    <div style={{ padding: 16, backgroundColor: 'var(--secondarys100)', borderRadius: 'var(--radius4)' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%', textAlign: 'center' }}>
                            <div className="body/b2 secondary/s800">
                                아직 다가오는 프로그램이 없습니다
                            </div>
                            <TextBtn type='underline' textDecorationColor='' style={{ color: 'var(--secondarys800)' }} onClick={() => navigate('/explore')} icon={false}>
                                프로그램 둘러보기
                            </TextBtn>
                        </div>
                    </div>
                </div>
                : sortedList.length === 1
                    ? sortedList.map((item, idx) => {
                        const isReservation = item.type === 'reservation';
                        return <div
                            ref={idx === 0 ? fristRef : null}
                            key={idx}
                            style={{ cursor: 'pointer', width: 'calc(100vw - 11vw)', maxWidth: 'calc(480px - 11vw)', paddingLeft: sortedList.length === 1 ? '5.5vw' : '3.3vw' }}
                            onClick={() =>
                                isReservation
                                    ? navigate(`/lecture/${item.id}`)
                                    : navigate(`/program/book/detail/${item.id}`)
                            }
                        >
                            <Flex align='center' justify='space-between' style={{ backgroundColor: 'var(--secondarys100)', borderRadius: '4px', padding: '12px', }} gap={16}>
                                <img
                                    src={item.imageUrl}
                                    alt={isReservation ? "수업사진" : "프로그램사진"}
                                    width={56}
                                    height={56}
                                    style={{ borderRadius: "999px", aspectRatio: 1, objectFit: 'cover' }}
                                />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div className="sub-title/st3" style={{ overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', }}>
                                        {item.title}
                                    </div>
                                    <div className="body/b1 secondary/s500" style={{ overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: 8 }}>
                                        {dayjs(item.startDateTime).format('YYYY.MM.DD (dd) HH:mm')}{item.locationName ? ' | ' + item.locationName : ''}
                                    </div>
                                </div>
                            </Flex>
                        </div>
                    })
                    : <div>
                        <CunstomAbleCarousel dataLength={sortedList.length} firstWidth={carouselWidth}>
                            {sortedList.map((item, idx) => {
                                const isReservation = item.type === 'reservation';
                                return <div
                                    ref={idx === 0 ? fristRef : null}
                                    key={idx}
                                    style={{ cursor: 'pointer', width: 'calc(100vw - 11vw)', maxWidth: 'calc(480px - 11vw)', paddingLeft: sortedList.length === 1 ? '5.5vw' : '3.3vw' }}
                                    onClick={() =>
                                        isReservation
                                            ? navigate(`/lecture/${item.id}`)
                                            : navigate(`/program/book/detail/${item.id}`)
                                    }
                                >
                                    <Flex align='center' justify='space-between' style={{ backgroundColor: 'var(--secondarys100)', borderRadius: '4px', padding: '12px', }} gap={16}>
                                        <img
                                            src={item.imageUrl}
                                            alt={isReservation ? "수업사진" : "프로그램사진"}
                                            width={56}
                                            height={56}
                                            style={{ borderRadius: "999px", aspectRatio: 1, objectFit: 'cover' }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div className="sub-title/st3" style={{ overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', }}>
                                                {item.title}
                                            </div>
                                            <div className="body/b1 secondary/s500" style={{ overflowX: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', marginTop: 8 }}>
                                                {dayjs(item.startDateTime).format('YYYY.MM.DD (dd) HH:mm')}{item.locationName ? ' | ' + item.locationName : ''}
                                            </div>
                                        </div>
                                    </Flex>
                                </div>
                            })}
                        </CunstomAbleCarousel>
                    </div>
            }
        </div>
    </div>
}
export { ReservatedProgramList };